<div class="panel-stack-container" [appResizable]="panelElements || []">
  @for (panel of panels; track panel; let i = $index) {
    <div class="panel" [ngClass]="{'show':panel.show}" #resizePanel>
      <div class="panel-resize-handle"></div>
      <div class="back-link">
        <a (click)="back()">< Back
        to {{panel.data?.previous_component === 'component' ? 'new component form' : panel.data?.previous_component?.attributes?.name || 'dashboard'}}</a>
      </div>
      @if (panel.type === 'component') {
        <new-component
          [data]="panel.data"
        (loadNewComponent)="loadRelatedComponent($event, panel, true)"></new-component>
      }
      @if (panel.type === 'component-detail') {
        <component-detail
          [data]="panel.data"
          (loadRelatedComponent)="loadRelatedComponent($event, panel)">
        </component-detail>
      }
    </div>
  }
  @if (panels?.length) {
    <button class="close-panel" (click)="close()"><i class="material-icons">close</i>
  </button>
}
</div>
